import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle--up",
  "use": "icon-triangle--up-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 11\" id=\"icon-triangle--up\"><path d=\"M7.229.935a1 1 0 0 1 1.542 0l6.54 7.929a1 1 0 0 1-.772 1.636H1.461a1 1 0 0 1-.772-1.636L7.23.935Z\" fill=\"#006442\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol